// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.
import { createSelector } from 'reselect'

import { fullFileStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../types/plottr').ShareRecord} ShareRecord
 */

export const fileSelector = createSelector(fullFileStateSelector, ({ file }) => file ?? {})
/**
 * @type {function(PlottrState): String}
 */
export const fileNameSelector = createSelector(fileSelector, ({ fileName }) => fileName ?? '')
/**
 * @type {function(PlottrState): String | Null}
 */
export const cloudFilePathSelector = createSelector(fileSelector, ({ isCloudFile, id }) => {
  return isCloudFile ? `plottr://${id}` : null
})
/**
 * @type {function(PlottrState): String | Null}
 */
export const fileIdSelector = createSelector(fileSelector, ({ id }) => {
  return id ?? null
})
/**
 * @type {function(PlottrState): String}
 */
export const fileVersionSelector = createSelector(fileSelector, ({ version }) => {
  return version
})
/**
 * @type {function(PlottrState): Array<ShareRecord>}
 */
export const shareRecordsSelector = createSelector(fileSelector, ({ shareRecords }) => {
  return shareRecords ?? []
})
/**
 * @type {function(PlottrState): (String | Null)}
 */
export const originalVersionStampSelector = createSelector(
  fileSelector,
  ({ originalVersionStamp }) => {
    return originalVersionStamp ?? null
  }
)
/**
 * @type {function(PlottrState): (String | Null)}
 */
export const currentVersionStampSelector = createSelector(fileSelector, ({ versionStamp }) => {
  return versionStamp ?? null
})
/**
 * @type {function(PlottrState): boolean}
 */
export const fileIsDeletedSelector = createSelector(fileSelector, ({ deleted }) => {
  return !!deleted
})
